import styled from "../../theme/styled-components";
import { defaultButtonCss } from "./Button";

export const ConfirmationButton = styled.button`
  ${defaultButtonCss};
  width: 100%;
  height: 4rem;
`;
